import { Box } from '@mui/material';
import { MobileTimePicker } from '@mui/x-date-pickers';
import moment                                                                         from 'moment';
import { ForwardRefRenderFunction, ReactNode, forwardRef, memo, useEffect, useState } from 'react';
import styled                                                                         from 'styled-components';
import { ReactComponent as IconTime }                                                 from '../../../../images/icons/icon-time.svg';
import { IconRemove }                                                                 from '../../../modules/MyFamilyCore/shared/styles';
import {
  ITextInputOwnProps,
}                                                                                     from '../../inputs/TextInput/TextInput';
import {
  DashedButtonIconLabel,
  DatePickerWrapper,
}                                                                                     from '../../styledComponents';
import {
  getMoment,
}                                                                                     from '../../utils/commonFunctions';
import { IEvent }                                                                     from '../../../modules/Schedule/queries';

const TimePickerElm = styled(MobileTimePicker)`
  display: none !important;
`;

export interface ISelectTimeProps
  extends ITextInputOwnProps {
  id?: string;
  schedule: Array<IEvent>;
  label: string;
  name?: string;
  value?: string | null;
  error?: boolean;
  helperText?: ReactNode;
  shrink?: boolean;
  disabled?: boolean;
  className?: string;
  onChange?: (event: unknown) => void;
}

const SelectTimeBase: ForwardRefRenderFunction<HTMLDivElement, ISelectTimeProps> = ({
  schedule,
  name,
  label,
  value,
  shrink = true,
  disabled,
  className,
  onChange,
  ...props
}, ref) => {
  const [ inputDate, setInputDate ] = useState<any>(null);
  const [ isOpen, setIsOpen ] = useState(false);

  const SelectPlaceholder = name === 'recursStartTime' ? 'Choose a Start Time' : 'Choose a End Time';

  useEffect(
    () => {
      console.log('value', value);
      const date = value ? getMoment(value) : null;
      setInputDate(date);
    },
    [ value ]
  );

  const updateDate = (momentValue: moment.Moment) => {
    const initialMoment = moment(value || undefined);
    const { hours, minutes } = momentValue.toObject();
    initialMoment.utc().set({ hours, minutes });

    return initialMoment.format('YYYY-MM-DDTHH:mm:ss');
  };

  const handleChange = (value: unknown) => {
    const inputMoment = value as moment.Moment | null;
    setInputDate(inputMoment);
  };

  const handleAccept = (value: unknown) => {
    const inputMoment = value as moment.Moment | null;

    if (!onChange) return;

    const updateValue = inputMoment ? updateDate(inputMoment) : null;

    onChange({ target: { value: updateValue, name } });
  };

  const onClear = (event: any) => {
    event.stopPropagation();
    onChange?.({ target: { value: null, name } });
  };

  return (
    <Box
      ref={ref}
      className={className}
      sx={{
        '& > div': {
          width: '100%',
        },
      }}
    >
      <DatePickerWrapper
        empty={!value}
        isSelectDate={false}
        onClick={() => setIsOpen(!isOpen)}
      >
        <DashedButtonIconLabel>
          <IconTime />
          { inputDate && moment(inputDate).format('hh:mm A') }
        </DashedButtonIconLabel>

        { inputDate ? <IconRemove onClick={onClear} /> : SelectPlaceholder }
      </DatePickerWrapper>

      <TimePickerElm
        open={isOpen}
        label={label}
        value={inputDate ?? moment()}
        format="hh:mm A"
        disabled={disabled}
        slotProps={{
          textField: {
            placeholder     : 'hh:mm A',
            InputLabelProps : { shrink },
            ...props,
          } as any,
          toolbar: {
            hidden : false,
            sx     : {
              backgroundColor                           : 'primary.main',
              color                                     : 'primary.contrastText',
              '& .MuiTimePickerToolbar-hourMinuteLabel' : {
                fontSize   : '3rem',
                alignItems : 'center',
              },
              '& .MuiTimePickerToolbar-ampmSelection': {
                marginLeft: 2,
              },
              '& .MuiTypography-root': {
                color: 'inherit',
              },
            },
          },
          layout: {
            sx: {
              '& .MuiPickersToolbar-root': {
                backgroundColor : 'primary.main',
                color           : 'primary.contrastText',
              },
            },
          },
        }}
        onChange={handleChange}
        onAccept={handleAccept}
        onClose={() => setIsOpen(false)}
      />
    </Box>
  );
};

export const SelectTime = memo(forwardRef(SelectTimeBase));
